import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { getSavedSearch } from './savedSearch';

export const goToRouteBySearch = (searchText?: string) => {
  const savedSearch = getSavedSearch();
  const savedFilterKey = savedSearch?.savedFilterData.filterKey;
  const savedFilterName = savedSearch?.savedFilterData?.filterName;
  const path = new URL(window.location.href).pathname;
  
  let route = `${path}?`;
  
  if (searchText) {
    const encodedSearchText = encodeURIComponent(searchText);
    route += `&search=${encodedSearchText}`;
  }

  if (savedFilterName) {
    route += `&filterKey=${savedFilterKey}&filterName=${savedFilterName}`;
  }

  browserHistory.push(getParameterizedLink(route));
};
